var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyesB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 35,
    viewBox: "0 0 112 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2876 4.13596C40.8514 8.74302 37.3173 32.171 34.2876 32.9153C28.2294 34.4038 10.0536 37.3811 9.04394 19.5181C8.03853 1.7307 24.5218 -2.71857 34.2876 4.13596Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 18.0731C33 24.1482 32.0751 28.0731 26 28.0731C19.9249 28.0731 19 24.1482 19 18.0731C19 11.9979 19.9249 8.07306 26 8.07306C32.0751 8.07306 33 11.9979 33 18.0731Z",
    className: "Eyes"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00029 18.573C8.00029 11.0696 13.9999 -1.42694 28.9999 1.57306C20.5001 -2.92694 1 2.07306 9.00029 18.573Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.0731C4.5 17.0731 6 17.0731 9 17.5731C9 19.5731 9 21.5731 9.5 23.0731C6 22.0731 3 19.5731 0 15.0731Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7124 4.20902C71.1486 8.81608 74.6827 32.2441 77.7124 32.9884C83.7706 34.4768 101.946 37.4542 102.956 19.5911C103.961 1.80376 87.4782 -2.64551 77.7124 4.20902Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79 18.1461C79 24.2213 79.9249 28.1461 86 28.1461C92.0751 28.1461 93 24.2213 93 18.1461C93 12.071 92.0751 8.14612 86 8.14612C79.9249 8.14612 79 12.071 79 18.1461Z",
    className: "Eyes"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M103 18.6461C104 11.1426 98.0001 -1.35389 83.0001 1.64611C91.4999 -2.85388 111 2.14612 103 18.6461Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M112 15.1461C107.5 17.1461 106 17.1461 103 17.6461C103 19.6461 103 21.6461 102.5 23.1461C106 22.1461 109 19.6461 112 15.1461Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyesB);
export default __webpack_public_path__ + "static/media/Eyes B.3d797cf39c4dc229d698ada4707fe4f2.svg";
export { ForwardRef as ReactComponent };